var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50091 0.224609C5.69807 0.224609 3.42591 2.49677 3.42591 5.29961C3.42591 7.61364 4.97465 9.56594 7.09213 10.1765C5.42049 10.3802 3.98671 10.9715 2.90661 12.0359C1.53193 13.3908 0.835938 15.4076 0.835938 18.0395C0.835938 18.4068 1.13368 18.7045 1.50094 18.7045C1.86821 18.7045 2.16594 18.4068 2.16594 18.0395C2.16594 15.6315 2.79991 14.0085 3.84018 12.9832C4.88241 11.9561 6.43834 11.4246 8.50084 11.4246C10.5633 11.4246 12.1193 11.9561 13.1616 12.9832C14.2018 14.0085 14.8359 15.6315 14.8359 18.0395C14.8359 18.4068 15.1335 18.7045 15.5009 18.7045C15.8681 18.7046 16.1659 18.4068 16.1659 18.0396C16.1659 15.4076 15.4698 13.3908 14.0952 12.0359C13.0151 10.9715 11.5813 10.3803 9.90966 10.1765C12.0271 9.56597 13.5759 7.61366 13.5759 5.29961C13.5759 2.49677 11.3038 0.224609 8.50091 0.224609ZM4.75591 5.29961C4.75591 3.23131 6.43261 1.55461 8.50091 1.55461C10.5692 1.55461 12.2459 3.23131 12.2459 5.29961C12.2459 7.36791 10.5692 9.04461 8.50091 9.04461C6.43261 9.04461 4.75591 7.36791 4.75591 5.29961Z",
    fill: "#4F4443"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.dc61920c.svg";
export { ForwardRef as ReactComponent };